import "./style/index.scss";
import dayjs from "dayjs";
import * as Icon from "@ant-design/icons";
import { Button, Row, Form, Col, Select, Switch, Empty, Tag, Tooltip, Flex, Skeleton, Image, Typography } from "antd";
import { useEffect, useState } from "react";
import { setSubTitle, setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import { buscarEmpresa } from "../../services/empresaService";
import { setBuscaComparativoResultado } from "../../redux/slices/comparativoResultado/comparativoResultadoSlice";
import { buscarComparativoResultado, warningComparacaoResultadoSorteio } from "../../services/comparativoResultadoService";
import { ComparativoResultadoEmpresaModel } from "../../models/comparativoResultado/comparativoResultadoEmpresaModel";
import { ColumnsType } from "antd/es/table";
import { EmpresaModel } from "../../models/empresa/empresaModel";
import { listarSorteio } from "../../services/sorteioService";
import TableComponent from "../../components/table/tableComponent";
import { BuscaComparativoResultadoModel } from "../../models/comparativoResultado/buscaComparativoResultadoModel";
import { removeFilhos } from "../../util/functions/removeFilhos";
import { toastWarning } from "../../util/toast";

dayjs.locale("pt-br");

const ComparativoResultadoEmpresa = () => {
  //estados globais
  const comparativoResultadoState = useAppSelector((state) => state.comparativoResultado);
  const empresaState = useAppSelector((state) => state.empresa);
  const sorteioState = useAppSelector((state) => state.sorteio);
  const persistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const [percentuais, setPorcentagem] = useState(false);
  const [empty, setEmpty] = useState(false);
  const [empresasSelecionadas, setEmpresaSelecionada] = useState([]);
  const [emEdicao, setEmEdicao] = useState(false);
  const [tipoResultado, setTipoResultado] = useState("");
  const [filters, setFilters] = useState<any>({} as any);

  useEffect(() => {
    dispatch(setTitle("RESUMO DO RESULTADO - ENTRE EMPRESAS"));
    dispatch(buscarEmpresa(empresaState.busca));
    if (persistedState.user.empresa !== null) {
      onChangeEmpresa([persistedState.user.empresa.idEmpresa]);
    }
  }, []);

  const onChangePercentuais = (checked: any) => {
    setPorcentagem(checked);
  };

  const onChangeEmpresa = (values: any) => {
    let itensSelecionados = values.map((value: any) => value);

    dispatch(listarSorteio(itensSelecionados.map(String).toString()));

    setEmpresaSelecionada(itensSelecionados);
    setEmEdicao(true);
  };

  const onChangeTipo = (value: string) => {
    if (value === "E") {
      setTipoResultado("E");
      dispatch(setSubTitle("PONTO DE EQUILÍBRIO"));
    }
    if (value === "P") {
      setTipoResultado("P");
      dispatch(setSubTitle("RESULTADO PARCIAL"));
    }
    if (value === "R") {
      setTipoResultado("R");
      dispatch(setSubTitle("RESULTADO FINAL"));
    }
  };

  const goRelatorio = () => {
    var denominacaoEmpresa = "";
    if (filters.idEmpresa) {
      filters.idEmpresa.split(",").forEach((a: any, index: number) => {
        var empresa = empresaState.list.find((empresa: EmpresaModel) => empresa.id === parseInt(a));
        if (empresa) {
          denominacaoEmpresa += empresa.apelido;
          if (index < filters.idEmpresa!.split(",").length - 1) {
            denominacaoEmpresa += ",";
          }
        }
      });
    }
    filters.empresasSelecionadas = denominacaoEmpresa;
    filters.porcentagem = percentuais;
    localStorage.setItem("entreEmpresa", JSON.stringify(comparativoResultadoState.list));
    localStorage.setItem("entreEmpresaFilter", JSON.stringify(filters));
    window.open("/relatorioEntreEmpresas", "_blank");
  };

  const submit = async (values: any) => {
    setEmpty(true);
    let busca: BuscaComparativoResultadoModel = {
      dataSorteio: values.dataSorteio,
      idEmpresa: persistedState.user.empresa !== null ? persistedState.user.empresa.idEmpresa.toString() : values.idEmpresa.join(",").toString(),
      tipoResultado: values.tipoResultado,
    };
    setFilters(busca);
    dispatch(setBuscaComparativoResultado({ ...busca, empresasSelecionadas: "", porcentagem: percentuais }));
    const retorno = await dispatch(warningComparacaoResultadoSorteio(busca));
    if (retorno.payload[0] !== "") {
      toastWarning(retorno.payload[0]);
    }
    dispatch(buscarComparativoResultado(busca));
    setEmEdicao(false);
  };

  const columns: ColumnsType<ComparativoResultadoEmpresaModel> = [
    {
      title: "",
      dataIndex: "denominacao",
      key: "0",
      width: 250,
      render: (_, record) => (
        <Typography.Text style={{ width: 180, fontSize:"12px" }} ellipsis={{ tooltip: record.denominacao }}>
          {record.denominacao}
        </Typography.Text>
      ),
    },
    {
      title: "VALOR",
      key: "1",
      dataIndex: ["valorEmpresa1", "percentualEmpresa1"],
      align: "right",
      render: (text: any, row: any) => {
        return (
          <>
            {percentuais ? (
              <>
                {row["percentualEmpresa1"] ? (
                  <div className={Math.sign(parseInt(row["valorEmpresa1"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa1"]}</div>
                    <Tag>{row["percentualEmpresa1"]}</Tag>
                  </div>
                ) : (
                  <div className={Math.sign(parseInt(row["valorEmpresa1"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa1"]}</div>
                    <div className="tagVazia"></div>
                  </div>
                )}
              </>
            ) : (
              <div className={Math.sign(parseInt(row["valorEmpresa1"])) === -1 ? "valorNegativo" : ""}>{row["valorEmpresa1"]}</div>
            )}
          </>
        );
      },
    },
    {
      title: "VALOR",
      key: "2",
      dataIndex: ["valorEmpresa2", "percentualEmpresa2"],
      align: "right",
      render: (text: any, row: any) => {
        return (
          <>
            {percentuais ? (
              <>
                {row["percentualEmpresa2"] ? (
                  <div className={Math.sign(parseInt(row["valorEmpresa2"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa2"]}</div>
                    <Tag>{row["percentualEmpresa2"]}</Tag>
                  </div>
                ) : (
                  <div className={Math.sign(parseInt(row["valorEmpresa2"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa2"]}</div>
                    <div className="tagVazia"></div>
                  </div>
                )}
              </>
            ) : (
              <div className={Math.sign(parseInt(row["valorEmpresa2"])) === -1 ? "valorNegativo" : ""}>{row["valorEmpresa2"]}</div>
            )}
          </>
        );
      },
    },
    {
      title: "VALOR",
      key: "3",
      dataIndex: ["valorEmpresa3", "percentualEmpresa3"],
      align: "right",
      render: (text: any, row: any) => {
        return (
          <>
            {percentuais ? (
              <>
                {row["percentualEmpresa3"] ? (
                  <div className={Math.sign(parseInt(row["valorEmpresa3"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa3"]}</div>
                    <Tag>{row["percentualEmpresa3"]}</Tag>
                  </div>
                ) : (
                  <div className={Math.sign(parseInt(row["valorEmpresa3"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa3"]}</div>
                    <div className="tagVazia"></div>
                  </div>
                )}
              </>
            ) : (
              <div className={Math.sign(parseInt(row["valorEmpresa3"])) === -1 ? "valorNegativo" : ""}>{row["valorEmpresa3"]}</div>
            )}
          </>
        );
      },
    },
    {
      title: "VALOR",
      key: "4",
      dataIndex: ["valorEmpresa4", "percentualEmpresa4"],
      align: "right",
      render: (text: any, row: any) => {
        return (
          <>
            {percentuais ? (
              <>
                {row["percentualEmpresa4"] ? (
                  <div className={Math.sign(parseInt(row["valorEmpresa4"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa4"]}</div>
                    <Tag>{row["percentualEmpresa4"]}</Tag>
                  </div>
                ) : (
                  <div className={Math.sign(parseInt(row["valorEmpresa4"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa4"]}</div>
                    <div className="tagVazia"></div>
                  </div>
                )}
              </>
            ) : (
              <div className={Math.sign(parseInt(row["valorEmpresa4"])) === -1 ? "valorNegativo" : ""}>{row["valorEmpresa4"]}</div>
            )}
          </>
        );
      },
    },
    {
      title: "VALOR",
      key: "5",
      dataIndex: ["valorEmpresa5", "percentualEmpresa5"],
      align: "right",
      render: (text: any, row: any) => {
        return (
          <>
            {percentuais ? (
              <>
                {row["percentualEmpresa5"] ? (
                  <div className={Math.sign(parseInt(row["valorEmpresa5"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa5"]}</div>
                    <Tag>{row["percentualEmpresa5"]}</Tag>
                  </div>
                ) : (
                  <div className={Math.sign(parseInt(row["valorEmpresa5"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa5"]}</div>
                    <div className="tagVazia"></div>
                  </div>
                )}
              </>
            ) : (
              <div className={Math.sign(parseInt(row["valorEmpresa5"])) === -1 ? "valorNegativo" : ""}>{row["valorEmpresa5"]}</div>
            )}
          </>
        );
      },
    },
    {
      title: "VALOR",
      key: "6",
      dataIndex: ["valorEmpresa6", "percentualEmpresa6"],
      align: "right",
      render: (text: any, row: any) => {
        return (
          <>
            {percentuais ? (
              <>
                {row["percentualEmpresa6"] ? (
                  <div className={Math.sign(parseInt(row["valorEmpresa6"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa6"]}</div>
                    <Tag>{row["percentualEmpresa1"]}</Tag>
                  </div>
                ) : (
                  <div className={Math.sign(parseInt(row["valorEmpresa6"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa6"]}</div>
                    <div className="tagVazia"></div>
                  </div>
                )}
              </>
            ) : (
              <div className={Math.sign(parseInt(row["valorEmpresa6"])) === -1 ? "valorNegativo" : ""}>{row["valorEmpresa6"]}</div>
            )}
          </>
        );
      },
    },
    {
      title: "VALOR",
      key: "7",
      dataIndex: ["valorEmpresa7", "percentualEmpresa7"],
      align: "right",
      render: (text: any, row: any) => {
        return (
          <>
            {percentuais ? (
              <>
                {row["percentualEmpresa7"] ? (
                  <div className={Math.sign(parseInt(row["valorEmpresa7"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa7"]}</div>
                    <Tag>{row["percentualEmpresa1"]}</Tag>
                  </div>
                ) : (
                  <div className={Math.sign(parseInt(row["valorEmpresa7"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa7"]}</div>
                    <div className="tagVazia"></div>
                  </div>
                )}
              </>
            ) : (
              <div className={Math.sign(parseInt(row["valorEmpresa7"])) === -1 ? "valorNegativo" : ""}>{row["valorEmpresa7"]}</div>
            )}
          </>
        );
      },
    },
    {
      title: "VALOR",
      key: "8",
      dataIndex: ["valorEmpresa8", "percentualEmpresa8"],
      align: "right",
      render: (text: any, row: any) => {
        return (
          <>
            {percentuais ? (
              <>
                {row["percentualEmpresa8"] ? (
                  <div className={Math.sign(parseInt(row["valorEmpresa8"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa8"]}</div>
                    <Tag>{row["percentualEmpresa8"]}</Tag>
                  </div>
                ) : (
                  <div className={Math.sign(parseInt(row["valorEmpresa8"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa8"]}</div>
                    <div className="tagVazia"></div>
                  </div>
                )}
              </>
            ) : (
              <div className={Math.sign(parseInt(row["valorEmpresa8"])) === -1 ? "valorNegativo" : ""}>{row["valorEmpresa8"]}</div>
            )}
          </>
        );
      },
    },
    {
      title: "VALOR",
      key: "9",
      dataIndex: ["valorEmpresa9", "percentualEmpresa9"],
      align: "right",
      render: (text: any, row: any) => {
        return (
          <>
            {percentuais ? (
              <>
                {row["percentualEmpresa9"] ? (
                  <div className={Math.sign(parseInt(row["valorEmpresa9"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa9"]}</div>
                    <Tag>{row["percentualEmpresa9"]}</Tag>
                  </div>
                ) : (
                  <div className={Math.sign(parseInt(row["valorEmpresa9"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa9"]}</div>
                    <div className="tagVazia"></div>
                  </div>
                )}
              </>
            ) : (
              <div className={Math.sign(parseInt(row["valorEmpresa9"])) === -1 ? "valorNegativo" : ""}>{row["valorEmpresa9"]}</div>
            )}
          </>
        );
      },
    },
    {
      title: "VALOR",
      key: "10",
      dataIndex: ["valorEmpresa10", "percentualEmpresa10"],
      align: "right" as "right",
      render: (text: any, row: any) => {
        return (
          <>
            {percentuais ? (
              <>
                {row["percentualEmpresa10"] ? (
                  <div className={Math.sign(parseInt(row["valorEmpresa10"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa10"]}</div>
                    <Tag>{row["percentualEmpresa10"]}</Tag>
                  </div>
                ) : (
                  <div className={Math.sign(parseInt(row["valorEmpresa10"])) === -1 ? "valorRow valorNegativo" : "valorRow"}>
                    <div>{row["valorEmpresa10"]}</div>
                    <div className="tagVazia"></div>
                  </div>
                )}
              </>
            ) : (
              <div className={Math.sign(parseInt(row["valorEmpresa10"])) === -1 ? "valorNegativo" : ""}>{row["valorEmpresa10"]}</div>
            )}
          </>
        );
      },
    },
  ];

  const displayedColumns = columns.filter((column) => Number.parseInt(column.key!.toString()) <= empresasSelecionadas.length);

  const displayedColumnsFinal = displayedColumns.map((column, index) => {
    if (index > 0) {
      const selectedEmpresa = empresasSelecionadas[index - 1];
      const empresa = empresaState.list.find((empresa: EmpresaModel) => empresa.id === selectedEmpresa);
      column.title = (
        <div style={{ alignItems: "center", backgroundColor: "white" }}>
          <Image style={{ maxHeight: "56px", maxWidth: "107px" }} preview={false} src={empresa?.urlLogotipoGrande} />
        </div>
      );
      return column;
    }
  });

  const determineRowClassNamePonto = (record: any) => {
    if (record.codigo === "RM_01") {
      return "rowGreen";
    } else if (record.codigo === "RM_03" || record.codigo === "RM_10") {
      return "rowYellow";
    } else if (record.codigo === "RM_08") {
      return "rowGray";
    }
    return ""; // Retorna uma string vazia se nenhuma classe especial for necessária
  };

  const determineRowClassNamePrevisto = (record: any) => {
    if (record.codigo === "RM_02") {
      return "rowYellow";
    } else if (record.codigo === "RM_04" || record.codigo === "RM_07" || record.codigo === "RM_10") {
      return "rowNeutro";
    } else if (record.codigo === "RM_03" || record.codigo === "RM_05" || record.codigo === "RM_06") {
      return "rowBold";
    }
    return ""; // Retorna uma string vazia se nenhuma classe especial for necessária
  };

  const determineRowClassNameFinal = (record: any) => {
    if (record.codigo === "RM_01") {
      return "rowNeutro";
    } else if (record.codigo === "RM_07") {
      return "rowLightGreen";
    } else if (record.codigo === "RM_08" || record.codigo === "RM_10") {
      return "rowBold";
    }
    return ""; // Retorna uma string vazia se nenhuma classe especial for necessária
  };

  return (
    <Flex vertical>
      <Form layout="vertical" form={form} onFinish={submit}>
        <Row gutter={12} align="bottom">
          <Col span={24}>
            <Flex gap={12}>
              {persistedState.user.empresa === null && (
                <Form.Item
                  label="Empresas"
                  name="idEmpresa"
                  rules={[
                    {
                      required: true,
                      message: "Campo obrigatório",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    mode="multiple"
                    optionFilterProp="label"
                    style={{ width: 500 }}
                    maxTagCount="responsive"
                    maxTagPlaceholder={(omittedValues) => (
                      <Tooltip
                        title={
                          <ul style={{ paddingLeft: 16, margin: 0 }}>
                            {omittedValues.map((field, index) => (
                              <li key={index}>{field.label}</li>
                            ))}
                          </ul>
                        }
                      >
                        <span>{`+ ${omittedValues.length} ...`}</span>
                      </Tooltip>
                    )}
                    placeholder="Selecione as empresas"
                    onChange={onChangeEmpresa}
                    loading={empresaState.loading}
                    options={empresaState.list.map((a: any) => ({
                      value: a.id,
                      label: a.apelido,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item
                label="Data do sorteio"
                name="dataSorteio"
                rules={[
                  {
                    required: true,
                    message: "Campo obrigatório",
                  },
                ]}
              >
                <Select
                  showSearch
                  optionFilterProp="label"
                  style={{ width: 140 }}
                  loading={sorteioState.loadingEmpresas}
                  options={sorteioState.listSorteioEmpresas.map((a: any) => ({
                    value: a.dataSorteio,
                    label: dayjs(a.dataSorteio).format("DD/MM/YYYY"),
                  }))}
                />
              </Form.Item>
              <Form.Item
                label="Tipo de Resultado"
                name="tipoResultado"
                rules={[
                  {
                    required: true,
                    message: "Campo obrigatório",
                  },
                ]}
              >
                <Select
                  style={{ width: 200 }}
                  options={[
                    { label: "Ponto de equilíbrio", value: "E", disabled: false },
                    { label: "Resultado parcial", value: "P", disabled: false },
                    { label: "Resultado final", value: "R", disabled: false },
                  ]}
                  onChange={onChangeTipo}
                />
              </Form.Item>
              <Form.Item label=" " name="button">
                <Button className="addButton buttonPrimary" htmlType="submit" icon={<Icon.MergeCellsOutlined />}>
                  COMPARAR
                </Button>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
      {comparativoResultadoState.list.length !== 0 && tipoResultado !== "R" ? (
        <Row gutter={12} style={{ marginBottom: "1%" }}>
          <Col className="cadastrarCol" span={8} offset={16}>
            <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
              <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                Visualizar % <Switch size="small" defaultChecked={percentuais} onChange={onChangePercentuais} />
              </div>
              <Button icon={<Icon.PrinterOutlined />} onClick={goRelatorio} disabled={comparativoResultadoState.loading} />
            </div>
          </Col>
        </Row>
      ) : comparativoResultadoState.list.length !== 0 ? (
        <Row gutter={12} style={{ marginBottom: "1%" }}>
          <Col className="cadastrarCol" span={8} offset={16}>
            <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
              <Button icon={<Icon.PrinterOutlined />} onClick={goRelatorio} disabled={comparativoResultadoState.loading} />
            </div>
          </Col>
        </Row>
      ) : (
        <></>
      )}
      {comparativoResultadoState.loading ? (
        <Flex
          style={{
            width: "100%",
            height: "400px",
            alignItems: "center",
          }}
          gap={12}
        >
          <Skeleton.Button style={{ height: "300px", width: 250, marginTop: "100px"  }} shape="square" active />
          <Skeleton.Button style={{ height: "400px" }} shape="square" block active />
          <Skeleton.Button style={{ height: "400px" }} shape="square" block active />
          <Skeleton.Button style={{ height: "400px" }} shape="square" block active />
          <Skeleton.Button style={{ height: "400px" }} shape="square" block active />
          <Skeleton.Button style={{ height: "400px" }} shape="square" block active />
          <Skeleton.Button style={{ height: "400px" }} shape="square" block active />
          <Skeleton.Button style={{ height: "400px" }} shape="square" block active />
        </Flex>
      ) : comparativoResultadoState.list.length !== 0 && !emEdicao ? (
        <div style={{ overflowY: "hidden" }}>
          <div className="comparativo-entre-empresas">
            <Row>
              <Col span={24}>
                <TableComponent
                  columns={displayedColumns}
                  expandable={{
                    childrenColumnName: "filhos",
                    defaultExpandAllRows: false,
                  }}
                  pagination={false}
                  loading={comparativoResultadoState.loading}
                  data={removeFilhos(comparativoResultadoState.list)}
                  rowKey="ordem"
                  rowClassName={
                    comparativoResultadoState.busca.tipoResultado === "E"
                      ? determineRowClassNamePonto
                      : comparativoResultadoState.busca.tipoResultado === "P"
                      ? determineRowClassNamePrevisto
                      : determineRowClassNameFinal
                  }
                  tableProps={{ className: "bordered-table" }}
                />
              </Col>
            </Row>
          </div>
        </div>
      ) : (
        <Empty description={empty ? <span>Não existem dados para comparar</span> : <span>Clique em comparar para obter os dados</span>} />
      )}
    </Flex>
  );
};

export default ComparativoResultadoEmpresa;
